import {
  Box,
  Button,
  CalendarIcon,
  ExpansionPanelProps,
  PencilAltIcon,
  SidebarExpansionPanel,
  Typography,
  useModal,
} from '@forgeglobal/design-framework'
import { CampaignSidebarCardList } from 'components/campaigns/CampaignSidebarCardList'
import { CreateCampaignModal } from 'components/campaigns/CreateCampaignModal'
import { useGetAllOfferingsQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

interface CampaignSidebarPanelProps extends Omit<ExpansionPanelProps, 'children'> {
  type: string
  title: string
}

const CampaignSidebarPanel: React.FC<CampaignSidebarPanelProps> = ({ type, title, ...props }) => {
  const [showModal, hideModal] = useModal(() => {
    return <CreateCampaignModal hideModal={hideModal} />
  }, [])

  const { data } = useGetAllOfferingsQuery()
  const campaigns = data?.allOfferings?.data ?? []
  const filteredCampaigns = campaigns.filter(campaign => campaign.status === type)

  return (
    <SidebarExpansionPanel
      icon={type === 'Draft' ? <PencilAltIcon /> : <CalendarIcon />}
      title={title}
      badgeCounter={filteredCampaigns.length}
      {...props}>
      {type === 'Draft' && (
        <Button onClick={showModal} fullWidth>
          Create Campaign
        </Button>
      )}
      {type === 'Upcoming' && filteredCampaigns.length === 0 && (
        <Box display="flex" justifyContent="center" alignItems="center" p={2}>
          <Typography color="primary" variant="overline">
            No campaigns scheduled
          </Typography>
        </Box>
      )}
      <CampaignSidebarCardList type={type} />
    </SidebarExpansionPanel>
  )
}

export { CampaignSidebarPanel }
